import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getSuppliers(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Supplier/List`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function searchSuppliersByName(searchTerm: string, limit: number = 10, seasonId?: number) {
  const params = new URLSearchParams();
  if (searchTerm) params.append("searchTerm", searchTerm);
  params.append("limit", limit.toString());
  
  if (seasonId) {
    params.append("seasonId", seasonId.toString());
  }

  return axiosInstance.get("Evaluation/SearchByName", {
    params,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}